import { Component, Vue, } from 'vue-property-decorator';

@Component<ActionIcon>({ })
export default class ActionIcon extends Vue { }
